import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import DeleteSweepIcon from "@material-ui/icons/DeleteSweep";
import { makeStyles } from "@material-ui/core/styles";
import { reportedUsersService } from "../../../services/index"
import Utils from "../../../utility";

const useStyles = makeStyles((theme) => ({
  Deleteicon: {
    color: "grey",
    "&:hover, &.Mui-focusVisible": { color: "#FF0027" },
  },
  topScrollPaper: {
    margin: "35px",
    alignItems: "flex-start",
  },
  topPaperScrollBody: {
    verticalAlign: "top",
  },
  deletePopupSuccessbutton:{
    width: '8rem',
    marginRight: '5px',
    height: '1.75rem',
    backgroundColor:'#001441',
    color: 'white',
    borderRadius: '3px',
    opacity: 1,
  }
}));

export default function ResponsiveDialog(props) {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();
  const theme = useTheme();
  // const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const deleteEntry = async () => {

    if (props.id != "undefined") {
      const reqObj = {
        _id: props.id,
      };
      const[err, res] = await Utils.parseResponse(
        reportedUsersService.deleteblockedUsers(reqObj));
        props.getblockUsers(res);
        props.handleClose();
        handleClose();
    }
  };

  return (
    <div>
      <Button
        // onClick={handleClickOpen}
        onClick={() => { handleClickOpen();
          deleteEntry();
        }}
        variant="contained"
        color="primary"
        style={{ padding: "3px 38px", backgroundColor: "#001441" }}
        className={classes.deletePopupSuccessbutton}
      >
        Yes
      </Button>

      <Dialog
        // fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        classes={{
          scrollPaper: classes.topScrollPaper,
          paperScrollBody: classes.topPaperScrollBody,
        }}
      >
        <DialogTitle id="responsive-dialog-title" align="center">
          {"Success!"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText align="center">
            <img align="center" src="/images/successicon.svg" />
          </DialogContentText>
        </DialogContent>
        <DialogContent>
          <DialogContentText>
          This entry delete Successfully
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}
